import { FC } from 'react'
import { Geometry } from '../Geometry.tsx'
import { Poi } from '@/js/types'
import { useAtomValue } from 'jotai'
import { effectiveActivePoiAtom } from '@/js/editor/state/poiAtoms.ts'

type PoiLayerProps = {
    poi: Poi
}

export const PoiLayer: FC<PoiLayerProps> = ({ poi }) => {
    const effectiveActivePoi = useAtomValue(effectiveActivePoiAtom)

    const renderedPoi = effectiveActivePoi?.id === poi.id ? effectiveActivePoi : poi

    return (
        <div key={poi.title}>
            {renderedPoi.geometries?.geometries.map((geometry, index) => {
                return <Geometry poi={renderedPoi} geometry={geometry} key={`${renderedPoi.id}-${index}`} id={index} />
            })}
        </div>
    )
}
